import Directory from '../../components/directory/directory.component';

import HomepageContainer from './homepage.styles';

const Homepage = () => {
    return (
        <HomepageContainer>
            <Directory />
        </HomepageContainer>
    )
}

export default Homepage;
